import { Configuration } from 'generated-sources';

import { API_MAP } from '../api-map';

const fromPairs = <K extends PropertyKey, V>(
  pairs: Iterable<readonly [K, V]>,
): Record<K, V> => Object.fromEntries(pairs) as Record<K, V>;

type ApiInstances = {
  [K in keyof typeof API_MAP]: InstanceType<(typeof API_MAP)[K]>;
};

const defaultHeaders: Record<string, string> = {};
let apiMapCache: ApiInstances | null = null;
let apiBasePathCache: string | null = null;

export const setDefaultApiHeader = (name: string, value?: string) => {
  if (value === undefined || value === '') {
    delete defaultHeaders[name];
    return;
  }

  defaultHeaders[name] = value;
};

export const initializeApi = (apiUrl: string): ApiInstances => {
  const basePath = apiUrl || import.meta.env.VITE_BACKEND_URL;

  if (apiMapCache && apiBasePathCache === basePath) {
    return apiMapCache;
  }

  const config = new Configuration({
    basePath,
    credentials: 'include',
    headers: defaultHeaders,
  });

  apiMapCache = fromPairs(
    Object.entries(API_MAP).map(([key, Instance]) => [
      key,
      new Instance(config),
    ]),
  ) as ApiInstances;

  apiBasePathCache = basePath;

  return apiMapCache;
};
